import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useEffect, useRef, useState } from 'react';

// Delivery times update with a delay after delivery type change
// and there is no way of knowing if the values were updated,
// if they happen to be equal for self-delivery and Wolt delivery
const WAIT_MS = 8000;

export const useDeliveryTimesUpdater = (venueSlug: string) => {
  const queryClient = useQueryClient();

  const [isDeliveryTimesLoading, setIsDeliveryTimesLoading] = useState(false);
  const deliveryTimesTimeout = useRef<NodeJS.Timeout | undefined>();

  // Clear any remaining timeout on unmount
  useEffect(() => {
    return () => {
      if (deliveryTimesTimeout.current) {
        clearTimeout(deliveryTimesTimeout.current);
      }
    };
  }, []);

  const updateDeliveryTimes = useCallback(() => {
    setIsDeliveryTimesLoading(true);
    deliveryTimesTimeout.current = setTimeout(async () => {
      deliveryTimesTimeout.current = undefined;
      await queryClient.invalidateQueries(['/v1/merchant-admin/venues/', venueSlug]);
      setIsDeliveryTimesLoading(false);
    }, WAIT_MS);
  }, [queryClient, venueSlug]);

  return { isDeliveryTimesLoading, updateDeliveryTimes };
};
